




















































import { defineComponent, computed } from '@vue/composition-api';
import { useRouter, RouteName } from '@/router';
import { useStakingStore } from '@/stores/Staking';
import { useStakingRewards } from '@/composables/useStakingRewards';
import FiatConvertedAmount from './FiatConvertedAmount.vue';
import ValidatorIcon from './staking/ValidatorIcon.vue';
import Amount from './Amount.vue';

export default defineComponent({
    name: 'StakingRewardsListItem',
    props: {
        hideIcon: {
            type: Boolean,
            required: false,
            default: false,
        },
        hideMonth: {
            type: Boolean,
            required: false,
            default: false,
        },
        monthlyReward: {
            type: Number,
            required: true,
        },
        month: {
            type: String,
            required: true,
        },
        validatorsAddresses: {
            type: Array as () => string[],
            required: true,
        },
    },
    setup(props) {
        const router = useRouter();
        const { validators: validatorList } = useStakingStore();
        const { getMonthLabel, isOngoingMonth } = useStakingRewards();

        const monthLabel = computed(() => getMonthLabel(props.month));
        const validators = computed(() => props.validatorsAddresses.map(
            (validator) => validatorList.value[validator] || { address: validator }),
        );

        // Check if we should show the "Ongoing" indicator
        const showOngoingIndicator = computed(() => isOngoingMonth(props.month));

        // Currently unused, as The Reward history is much too large
        const openRewardsHistory = () => {
            if (router.currentRoute.name === RouteName.Staking) {
                router.replace({
                    name: RouteName.StakingRewards,
                    params: { month: props.month },
                });
            } else {
                router.push({
                    name: RouteName.StakingRewards,
                    params: { month: props.month },
                });
            }
        };

        return {
            openRewardsHistory,
            monthLabel,
            validators,
            showOngoingIndicator,
        };
    },
    components: {
        Amount,
        FiatConvertedAmount,
        ValidatorIcon,
    },
});
